import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isFetching, ResourcesList } from 'redux-and-the-rest';

import { IslandModel } from '../../../models/islandModel';
import { getOrFetchIslands } from '../../../redux/reducers/islandReducer';
import { ApplicationState } from '../../../redux/types';
import LoadingIndicator from '../../shared/LoadingIndicator';
import AddEditIsland from './AddEditIsland';
import IslandList from './IslandList';
import AddIcon from '../../../assets/add.svg';

import './Index.scss';
import VerticalScroller from '../../shared/VerticalScroller';

interface Props {
  islands: ResourcesList<IslandModel>;
  onSelectIsland?: (islandId: string) => void;
  selectedIslandId?: string;
}

const ManageIslandsWizard = ({
  islands, onSelectIsland, selectedIslandId,
}: Props): React.ReactElement => {
  const [isAdding, setIsAdding] = useState(false);

  return (
    <div className="manage-islands-wizard loadable">
      {isFetching(islands) ? (
        <LoadingIndicator />
      ) : (
        <>
          <VerticalScroller>
            <IslandList
              onSelectIsland={onSelectIsland}
              selectedIslandId={selectedIslandId}
            />
          </VerticalScroller>

          <div className="actions">
            {!isAdding && (
              <button
                type="button"
                onClick={() => setIsAdding(true)}
                className="button primary icon-button"
              >
                <img src={AddIcon} alt="Add new item" className="icon" />
              </button>
            )}

            {isAdding && (
              <AddEditIsland
                onCancel={() => setIsAdding(false)}
                onComplete={() => setIsAdding(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = ({ islands }: ApplicationState) => ({
  islands: getOrFetchIslands(islands),
});

export default connect(mapStateToProps)(ManageIslandsWizard);
